import Layout from './Layout';
import { useTranslation } from 'react-i18next';
import { GroupField, RoleField } from 'Pages/User/components';

const Roles = ({ isProfile }: { isProfile: boolean }) => {
	const { t } = useTranslation();

    return <Layout title={t(`profile.permission.title`)} description={t(`profile.permission.description`)} parentClass="permission-section">
        <GroupField {...{ isProfile }} />
        <RoleField {...{ isProfile }} />
    </Layout>
}

export default Roles;
